export default __webpack_public_path__ + "static/media/papen.d0c95583.png";